import { render } from "./PageNotFound.vue?vue&type=template&id=72545f32&scoped=true"
const script = {}

import "./PageNotFound.vue?vue&type=style&index=0&id=72545f32&lang=scss&scoped=true"

import exportComponent from "/Users/andyhsieh/Desktop/tourist-site-project-master/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-72545f32"]])

export default __exports__